import React, { useState, useEffect } from 'react';
import { apiBase, getApiData, postApiData } from './api';
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay-ts';
import { SelectColumn, TreeDataGrid } from 'react-data-grid';
import Pager from './Pager'
import Select from 'react-select'


const LinkFormatter = ({ row, column }) => {
    const cellValue = row[column.key];
    const cellLink = row['link'];
  
    if(cellLink) {
      return <a href={cellLink} target="_blank" rel="noopener noreferrer">{cellValue}</a>;
    } else {
      return <div>{cellValue}</div>;
    }
};


  
function Details({ selectData, idToken, refreshToken, isLoggedIn, setIsLoggedIn, setTotalRows }) {
  const [allRows, setAllRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [isGridLoading, setIsGridLoading] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState(false);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(5000);

  const [cellFilter, setCellFilter] = useState("");
  const [rowFilter, setRowFilter] = useState("");

  function setSortHandler(e, p) {
    console.log(`Setting sort (${e.target})`);
    console.log(`Setting sort (${p.column.name})`);

    setSort(p.column.name);
  }

  function setSort(column_name, filter) {
    const newSortDirection = !sortDirection;

    setSortColumn(column_name);
    setSortDirection(newSortDirection);

    const sortedTopicData = sortData(allRows, column_name, newSortDirection);

    setTotalRows(sortedTopicData.length);
    setAllRows(sortedTopicData);

    var rows = sortedTopicData;
    if(filter) {
      rows = sortedTopicData.filter((row) => row[column_name] === filter);
    }
    const newRows = rows.slice(pageIndex * pageSize, pageIndex * pageSize + pageSize);

    setRows(newRows);
  }

  function sortData(topicData, currentSortColumn, currentSortDirection) {
    console.log(`Sorting data by column (${currentSortColumn}) direction (${currentSortDirection})`);

    const sortUp = currentSortDirection ? 1 : -1;
    const sortDown = currentSortDirection ? -1 : 1;

    var sortedTopicData = null;

    if(currentSortColumn) {
      console.log(`BB Sorting data by column (${currentSortColumn}) direction (${currentSortDirection})`);
      sortedTopicData = topicData.sort((b, a) => `${a[currentSortColumn]} ${a.item_date} ${a.item_hour.padStart(2, '0')}` > `${b[currentSortColumn]} ${b.item_date} ${b.item_hour.padStart(2, '0')}` ? sortUp : sortDown);
      console.log(`first column value: ${sortedTopicData[0][currentSortColumn]} ${sortedTopicData[0].item_date} ${sortedTopicData[0].item_hour.padStart(2, '0')}`);
    } else {
      console.log(`BB Sorting data by date`);
      sortedTopicData = topicData.sort((b, a) => `${a.item_date} ${a.item_hour.padStart(2, '0')}` > `${b.item_date} ${b.item_hour.padStart(2, '0')}` ? sortUp : sortDown);
    }

    return sortedTopicData;
  }

  function handleCellClick(params) {
    console.log('Cell clicked:', params); // Contains details about the clicked cell
    console.log('Row data:', params.row); // Access the data in the row
    // console.log('Field:', params.selectCell()); // The field/column clicked
    // console.log('Value:', params.value); // The value of the cell clicked
  
    const key = params.column.key;
    const value = params.row[key];
  
    console.log(`value (${value}) key (${key})`);
  
    console.log(`params ${JSON.stringify(params)}`);

    if(cellFilter) {
      setCellFilter("");
      setSort(key);
    } else {
      setCellFilter(value);

      setSort(key, value);
    }
  }

  function filterRows(rows, currentRowFilter) {
    console.log(`Filtering rows ${currentRowFilter}`);
    return rows.filter((row) => 
         row['single_line_tldr'].toLowerCase().includes(currentRowFilter)
      || row['feed_id'].toLowerCase().includes(currentRowFilter)
      || row['primary_company'].toLowerCase().includes(currentRowFilter)
      || row['primary_person'].toLowerCase().includes(currentRowFilter)
      || row['category'].toLowerCase().includes(currentRowFilter)
      || row['general_category'].toLowerCase().includes(currentRowFilter)
      || row['sentiment'].toLowerCase().includes(currentRowFilter)
      || row['technical_level'].toLowerCase().includes(currentRowFilter)
      || row['writing_style'].toLowerCase().includes(currentRowFilter)
      || row['article_language'].toLowerCase().includes(currentRowFilter)
  );
  }

  function updateRowFilter(e) {
    const filter = e.target.value;
    console.log(`Filtering rows ${filter}`);
    setRowFilter(e.target.value);

    if(filter) {
      const filteredRows = filterRows(allRows, filter);
      setRows(filteredRows);
    } else {
      setRows(allRows);
    }

    return true;
  }

  function updateCellFilter(e) {
    const filter = e.target.value;
    console.log(`Filtering rows ${filter}`);
    setCellFilter(filter);

    return true;
  }

  const keys = ['item_date', 'item_hour', 'single_line_tldr', 'feed_id', 'primary_company', 'primary_person', 'category', 'general_category', 'sentiment', 'technical_level', 'writing_style', 'sales_promotion', 'cybersec', 'cve', 'devops', 'ux', 'software_development', 'article_language', 'link'];

  const columns = keys.map((item) => {
    const columnDefinition = ({ 
      key: item, 
      name: item, 
      frozen: false, 
      resizable: true,
      // sortable: true,
    });

    if((item === 'single_line_tldr') || (item === 'item_date') || (item === 'item_hour')) {
      console.log('frozen');
      columnDefinition.frozen = true;
    }

    if(item === 'single_line_tldr') {
      columnDefinition.renderCell = LinkFormatter;
      // columnDefinition.renderHeaderCell = (p) => <input type="text" value={p.column.name} readOnly={true} style={{ width: '100%' }} />;
      columnDefinition.width = 200;
      columnDefinition.minWidth = 200;
    } else if(item === 'cybersec') {
      const yn = [
        { value: 'Y', label: 'Yes', isDisabled: false },
        { value: 'N', label: 'No' },
      ];

      // columnDefinition.renderCell = LinkFormatter;
      columnDefinition.renderHeaderCell = (p) => 
        <div>
          {p.column.name}
          {/* <Select options={yn} name={p.column.name}/> */}
          <select>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>
        </div>;
      // <input type="text" value={p.column.name} readOnly={true} style={{ width: '100%' }} />;
    } else {
      // columnDefinition.renderCell = LinkFormatter;
      columnDefinition.renderHeaderCell = (p) => 
        <div onClick={(e) => setSortHandler(e, p)}>
          {p.column.name}
        </div>;
      // <input type="text" value={p.column.name} readOnly={true} style={{ width: '100%' }} />;

    }

    return (columnDefinition);
  });

  const pageSizeOptions = [
    { value: 100, label: "100"},
    { value: 200, label: "200"},
    { value: 500, label: "500"},
  ];


  const options = ['general_category', 'category', 'primary_person', 'primary_company', 'sentiment', 'technical_level', 'writing_style', 'article_language', 'feed_id'];

  // const direction = useDirection();
  // const [rows] = useState(createRows);
  const [selectedRows, setSelectedRows] = useState(() => new Set());
  const [selectedOptions, setSelectedOptions] = useState([
    // 'category'
    // ,'general_category'
    // ,'primary_company'
    // options[0],
    // options[1]
  ]);
  const [expandedGroupIds, setExpandedGroupIds] = useState(
    () =>
      new Set()
  );

  function rowKeyGetter(row) {
    return [
      row.item_date,
      row.item_hour,
      row.feed_id,
      row.link,
      row.single_line_tldr,
    ].join('|');
  }

  function rowGrouper(rows, columnKey) {
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.groupBy(rows, (r) => r[columnKey]);
  }

  function toggleOption(option, enabled) {
    const index = selectedOptions.indexOf(option);
    if (enabled) {
      if (index === -1) {
        setSelectedOptions((options) => [...options, option]);
      }
    } else if (index !== -1) {
      setSelectedOptions((options) => {
        const newOptions = [...options];
        newOptions.splice(index, 1);
        return newOptions;
      });
    }
    setExpandedGroupIds(new Set());
  }

  async function makeAiSummary(rows) {
    console.log(`Making AI summary (${rows.length})`);

    setIsGridLoading(true);
    const feedTopicSummaryUrl = `${apiBase()}/m/get_feed_topic_rows`;

    var cellData = null;
    console.log("fetching data");
    const fetchResponse = await postApiData(feedTopicSummaryUrl, selectData, idToken, refreshToken, setIsLoggedIn); //.then(async (fetchResponse) => {
    console.log("data fetched");
    const responseData = fetchResponse.data;
    const topicDataUrl = responseData.url;
    console.log(topicDataUrl);

  }

  useEffect(() => {
    async function fetchData() {
      console.log("Updating details");
      console.log(`selectData: ${JSON.stringify(selectData)}`);


      const selectorsHaveData = Object.keys(selectData).some((key) => selectData[key].length > 0);
      if(!selectData || (Object.keys(selectData).length === 0) || !selectorsHaveData) {
        return;
      }
    
      setIsGridLoading(true);
      const feedTopicSummaryUrl = `${apiBase()}/m/get_feed_topic_rows`;

      var cellData = null;
      console.log("fetching data");
      const fetchResponse = await postApiData(feedTopicSummaryUrl, selectData, idToken, refreshToken, setIsLoggedIn); //.then(async (fetchResponse) => {
      console.log("data fetched");
      const responseData = fetchResponse.data;
      const topicDataUrl = responseData.url;
      console.log(topicDataUrl);

      // fetch the topic data from the URL using axios
      const topicDataResponse = await axios.get(topicDataUrl);
      console.log(topicDataResponse);
      const topicData = topicDataResponse.data;
      console.log(topicData);

      const sortedTopicData = sortData(topicData, sortColumn, sortDirection);

      setTotalRows(sortedTopicData.length);
      setAllRows(sortedTopicData);
  
      const newRows = sortedTopicData.slice(pageIndex * pageSize, pageIndex * pageSize + pageSize);
  
      setRows(newRows);
  
      if (!sortedTopicData) return <div>Click a cell to see details...</div>;

      setIsGridLoading(false);


    //   console.log(cellData);
    //   console.log(cellData[0]);
      
    //   setRows(cellData);
    //   console.log(rows);
    }
    if(isLoggedIn) {
      fetchData();
    }
  }, [selectData, idToken, refreshToken]);

  if(allRows && (allRows.length > 0)) {
    return (
      // <div style={{ position: 'relative', bottom: 0, width: '80%', overflow: 'auto' }}>
      // <div>
      <LoadingOverlay
          active={isGridLoading}
          spinner
          text='Loading your content...'
          style={{ width: '100%', height: '100%' }}
        >
            <b>Group by columns:</b>
            {/* <div  style={{width: '90%' }}> */}
            <div>
              {options.map((option) => (
                <label key={option}>
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(option)}
                    onChange={(event) => toggleOption(option, event.target.checked)}
                  />{' '}
                  {option}
                </label>
              ))}
            </div>
            <div>
              <input type="text" value={rowFilter} readOnly={false} onChange={updateRowFilter} style={{ width: '30%' }} />
              {/* <input type="text" value={cellFilter} readOnly={false} onChange={updateCellFilter} style={{ width: '100%' }} /> */}
              <button onClick={() => makeAiSummary(rows)}>AI</button>
            </div>
            <TreeDataGrid
                columns={columns}
                rows={rows}
                // rows={allRows}
                style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }} // Adjust height as needed
                rowKeyGetter={rowKeyGetter}
                // selectedRows={selectedRows}
                // onSelectedRowsChange={setSelectedRows}
                groupBy={selectedOptions}
                rowGrouper={rowGrouper}
                expandedGroupIds={expandedGroupIds}
                onExpandedGroupIdsChange={setExpandedGroupIds}
                // defaultColumnOptions={{ resizable: true }}
                // direction={direction}
                onCellClick={handleCellClick}
                
            ></TreeDataGrid>
            <Pager 
                allRows={allRows}
                rows={rows}
                setRows={setRows}
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                pageSize={pageSize}
                setPageSize={setPageSize}
            ></Pager>
        </LoadingOverlay>
      // </div>
    );
  } else {
    return (
      <LoadingOverlay
        active={isGridLoading}
        spinner
        text='Loading your content...'
      >      
        <div>Please filter</div>
      </LoadingOverlay>
    )
  }
}

export default Details;
